<template>
  <div class="archived-activities-page">
    <ActionsHeader @activitySearch="activitySearch" @filterChanged="onFilterChanged" @onOrganizeByChange="onOrganizeByChange" :allFilterTypes="allFilterTypes" :viewMode="viewMode" @updateColumns="updateColumns()">
      <router-link :to="{ name: 'activity-library-homepage' }" class="d-block tags-page__back-to-activities fs-14"> <img src="static/img/activity-configurator/arrow-left.svg" alt /> Back to Activities </router-link>
    </ActionsHeader>
    <div class="row">
      <div :class="showPreview == true ? 'table-container col-lg-5 p-0' : 'table-container col-lg-12 p-0'" v-if="views">
        <ArchivedTable
          v-for="(activitiesOfGroup, groupName) in activities"
          :key="groupName"
          :data="activitiesOfGroup && activitiesOfGroup.rows ? activitiesOfGroup.rows : []"
          :count="activitiesOfGroup.count"
          :title="groupName"
          :views="views"
          :currentView="currentView"
          @changeView="changeView"
          @previewActivity="previewActivity($event)"
          style="margin-bottom: 25px"
          @onSortColumn="onSortColumn($event, groupName)"
          @onPageChange="onPageChange"
          :pagination="paginationDetails[groupName]"
          :viewMode="viewMode"
          :previewSelectedId="previewSelectedId"
        />
      </div>
      <div class="preview-activity col-lg-6 ml-60 mt-30 pt-15 container-stylee float-right bg-white" v-if="!isDisplayGroupwise && views && showPreview == true">
        <div class="row mb-15">
          <div class="col-lg-4 device-view-btn" v-if="showStepView == true" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/surveyPreview/phone.png" />Device view</div>
          <div class="col-lg-4 device-view-btn" v-if="showStepView == false" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/activity-configurator/device-step-preview.svg" />Step view</div>
          <div class="col-lg-4 activity-data-name-preview" v-if="showStepView == true">
            {{ activityData.name }}
          </div>
          <div class="col-lg-4 p-0" v-if="showStepView == true">
            <div class="row float-right">
              <div class="col-lg-6 pb-10">{{ activityData.stepsCount }}&nbsp;Screens</div>
              <div v-if="activityData.timeToComplete" class="col-lg-6 pb-10">{{ activityData.timeToComplete }}&nbsp;min</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="showStepView == true">
            <readOnlyQuestions class :questions="questionAnswers" :activityData="activityData" :hideEditBtn="true" @editedEvent="questionIsEdited"></readOnlyQuestions>
          </div>
          <div v-if="showStepView == false" class="device-view-preview">
            <deviceQuestionsView class :questions="questionAnswers" :activityData="activityData" @editedEvent="questionIsEdited"></deviceQuestionsView>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ActionsHeader from "@/components/activity-library/activity-library-actions-header";
import ArchivedTable from "@/components/activity-library/archived-table";
import * as columnNames from "@/constants/activity-library-and-configurator-component/column-names";
import readOnlyQuestions from "@/components/activity-library/activity-preview-read-only-questions";
import deviceQuestionsView from "@/components/activity-library/activity-device-view";

const defaultView1 = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA, columnNames.CREATED_BY, columnNames.GROUP, columnNames.STEPS, columnNames.DURATION, columnNames.LANGUAGE, columnNames.LAST_MODIFIED];
const defaultView2 = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA, columnNames.TAGS, columnNames.STUDIES, columnNames.STEPS, columnNames.DURATION, columnNames.LANGUAGE];

export default {
  name: "ArchivedActivitesPage",

  components: {
    ActionsHeader,
    ArchivedTable,
    readOnlyQuestions,
    deviceQuestionsView
  },

  data() {
    return {
      showPreview: false,
      showStepView: true,
      activityData: { title: "", nickName: "", questions: [] },
      currentView: 1,
      filterObj: {},
      activityTypes: {},
      therapeuticAreas: {},
      activities: null,
      isDisplayGroupwise: false,
      initialActivityQueryParams: {
        pageNum: 1,
        pageSize: 20,
        sortOrder: "DESC",
        sortValue: "modified_time"
      },
      VIEW_1: 1,
      VIEW_2: 2,
      views: null,
      defaultView1,
      defaultView2,
      allFilterTypes: {
        AREA: "therapeuticAreaId",
        TYPE: "typeId",
        CREATEDBY: "createdBy",
        LANGUAGES: "language"
      },
      pagination: {
        current: 1,
        total: 1
      },
      questionAnswers: [],
      organizeByTitles: [],
      queryParams: {},
      paginationDetails: {},
      DEFAULT_ACTIVITY_PAGE_SIZE: 20,
      DEFAULT_ORGAINZE_BY_PAGE_SIZE: 20,
      organizeByQueryParam: null,
      viewMode: false,
      previewSelectedId: null
    };
  },
  watch: {
    isDisplayGroupwise(val) {
      if (!val) {
        this.organizeByActivities = null;
        this.organizeByTitles = [];
      }
    }
  },
  methods: {
    updateColumns() {
      this.getActivityViews();
    },
    toggleStepView() {
      this.showStepView = !this.showStepView;
    },
    questionIsEdited() {},
    previewActivity(previewActivityObj) {
      const activityId = previewActivityObj.activityId;
      this.previewSelectedId = previewActivityObj.previewSelectedId;
      if (previewActivityObj.id === this.previewSelectedId) {
        this.showPreview = !this.showPreview;
      } else {
        this.showPreview = true;
      }
      if (this.previewSelectedId == previewActivityObj.id) {
        this.previewSelectedId = null;
      } else {
        this.previewSelectedId = previewActivityObj.id;
      }

      this.showStepView = true;
      if (this.showPreview == false) {
        this.views = this.originalViews;
      }
      if (this.showPreview == true) {
        this.views = {};
        this.views[this.VIEW_1] = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA];
        this.views[this.VIEW_2] = [columnNames.NAME, columnNames.TYPE, columnNames.THERAPUETIC_AREA];
        this.activityData = {};
        this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
        this.getActivityDetails(activityId, previewActivityObj.revisionId);
      }
    },
    getActivityDetails(activityId, revisionId) {
      this.$api.getActivityDetails(activityId, revisionId).then(
        response => {
          this.activityData = response.data.result;
          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(response.data.result.questions);
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          this.$toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(value => {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    activitySearch(search) {
      this.filterObj.name = search;
      this.setAllTablesToFirstPage();
      this.getActivitiesList();
    },
    onOrganizeByChange(organizeByValue) {
      // Organize by value will be empty for 'All Activities'
      this.activities = null;
      this.queryParams = null;
      this.pagination.current = 1;
      if (organizeByValue) {
        this.isDisplayGroupwise = true;
        this.organizeByQueryParam = organizeByValue;
        this.initialActivityQueryParams.pageSize = this.DEFAULT_ORGAINZE_BY_PAGE_SIZE;
      } else {
        this.organizeByQueryParam = null;
        this.isDisplayGroupwise = false;
        this.initialActivityQueryParams.pageSize = this.DEFAULT_ACTIVITY_PAGE_SIZE;
      }
      this.organizeByTitles = [];
      this.getActivitiesList();
    },
    // No need to pass tableTitle for the initial get call

    getActivitiesList(tableTitle) {
      const filterObj = { ...this.filterObj };
      let queryParams;
      filterObj.status = "Archived";
      const filterObjStringified = JSON.stringify(filterObj);
      this.initialActivityQueryParams.pageNum = 0;
      if (this.queryParams && this.queryParams[tableTitle]) {
        queryParams = { ...this.queryParams[tableTitle] };
      } else {
        queryParams = { ...this.initialActivityQueryParams };
        this.queryParams = {};
      }
      if (this.organizeByQueryParam !== null) {
        queryParams.groupBy = this.organizeByQueryParam;
        queryParams.pageSize = this.DEFAULT_ORGAINZE_BY_PAGE_SIZE;
      } else {
        queryParams.pageSize = this.DEFAULT_ACTIVITY_PAGE_SIZE;
      }
      this.$api
        .getActivitiesList(filterObjStringified, queryParams)
        .then(response => {
          if (response.data.result) {
            this.activities = null;
            const activities = response.data.result;
            const titles = Object.keys(activities);
            this.activities = {};
            _.forEach(titles, title => {
              // Setting Pagination Data

              if (!this.paginationDetails[title]) {
                this.$set(this.paginationDetails, title, {});
                this.paginationDetails[title].total = 0;
                this.paginationDetails[title].current = 0;
              }

              // Setting Query Params Data
              if (!this.queryParams[title]) {
                this.$set(this.queryParams, title, {
                  ...this.initialActivityQueryParams
                });
              }

              this.$set(this.activities, title, activities[title]);

              if (this.isDisplayGroupwise) {
                this.organizeByTitles.push(title);
              }

              const pageSize = this.isDisplayGroupwise ? this.DEFAULT_ORGAINZE_BY_PAGE_SIZE : this.DEFAULT_ACTIVITY_PAGE_SIZE;
              let totalPages = Math.floor(this.activities[title].count / pageSize) + 1;
              if (this.activities[title].count % pageSize === 0) {
                totalPages -= 1;
              }
              if (this.activities[title].count === 0) {
                totalPages = 1;
              }
              this.paginationDetails[title].total = totalPages;

              _.forEach(this.activities[title].rows, activity => {
                if (activity.typeId && this.activityTypes[activity.typeId]) {
                  activity.type = this.activityTypes[activity.typeId].type;
                }
                if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                  activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
                }
              });
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Published activities");
        });
    },
    onFilterChanged(filter) {
      this.filterObj = { ...this.filterObj, ...filter };
      this.pagination.current = 1;
      this.setAllTablesToFirstPage();
      this.getActivitiesList();
    },
    setDefaultViews() {
      this.views = {};
      this.views[this.VIEW_1] = this.defaultView1;
      this.views[this.VIEW_2] = this.defaultView2;
    },
    setAllTablesToFirstPage() {
      if (!this.paginationDetails) {
        return;
      }

      const tableTitles = Object.keys(this.paginationDetails);

      if (!tableTitles.length) {
        return;
      }

      tableTitles.forEach(title => {
        this.paginationDetails[title].current = 0;
      });
    },
    getActivityViews() {
      this.$api
        .getActivityViews()
        .then(response => {
          const views = response.body.result || [];
          if (views.length) {
            const tempCol1 = [];
            let tempName1 = [];
            const respCols1 = views[0].cols.split(",");
            _.forEach(respCols1, columnName => {
              tempName1 = columnName.split("#");
              if (tempName1[1] == "1") {
                tempCol1.push(tempName1[0]);
              }
            });

            const tempCol2 = [];
            let tempName2 = [];
            const respCols2 = views[1].cols.split(",");
            _.forEach(respCols2, columnName => {
              tempName2 = columnName.split("#");
              if (tempName2[1] == "1") {
                tempCol2.push(tempName2[0]);
              }
            });

            this.views = {};
            this.views[this.VIEW_1] = tempCol1;
            this.views[this.VIEW_2] = tempCol2;
            this.originalViews = _.cloneDeep(this.views);
            this.isViewEmpty = false;
          } else {
            this.setDefaultViews();
          }
        })
        .catch(() => {
          this.$toastr.error("Failed to get activity views. Setting default views for now");
          this.setDefaultViews();
        });
    },
    onSortColumn({ column, order }, tableTitle) {
      let sortValue = column.name;
      if (column.name === "therapeuticArea") {
        sortValue = "therapeuticAreaId";
      }
      if (column.name === "type") {
        sortValue = "typeId";
      }
      this.paginationDetails[tableTitle].current = 0;
      this.queryParams[tableTitle] = {
        ...this.queryParams[tableTitle],
        sortValue,
        sortOrder: order,
        pageNum: this.paginationDetails[tableTitle].current
      };
      this.getActivitiesListForATable(tableTitle);
    },
    onPageChange({ direction, tableTitle }) {
      if (this.paginationDetails[tableTitle].current === 0 && direction === -1) {
        return;
      }

      if (this.paginationDetails[tableTitle].current + 1 === this.paginationDetails[tableTitle].total && direction === 1) {
        return;
      }

      this.paginationDetails[tableTitle].current += direction;
      this.queryParams[tableTitle].pageNum = this.paginationDetails[tableTitle].current;

      this.getActivitiesListForATable(tableTitle);
    },
    setPaginationData(count, pageSize) {
      const numberOfPages = Math.floor(count / pageSize);
      this.pagination.total = numberOfPages;
    },

    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          const therapeuticAreas = response.data.result;
          _.forEach(therapeuticAreas, therapeuticArea => {
            this.therapeuticAreas[therapeuticArea.id] = therapeuticArea;
          });
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.getActivitiesList();
          const activityTypes = response.data.result;
          _.forEach(activityTypes, activityType => {
            this.activityTypes[activityType.id] = activityType;
          });
          this.getActivitiesList();
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },

    changeView(view) {
      this.currentView = view;
    },
    getActivitiesListForATable(tableTitle) {
      const filterObj = { ...this.filterObj };
      filterObj.status = "Archived";
      const filterObjStringified = JSON.stringify(filterObj);
      this.queryParams[tableTitle].pageNum = this.paginationDetails[tableTitle].current;
      const queryParams = { ...this.queryParams[tableTitle] };
      if (this.organizeByQueryParam !== null) {
        queryParams.groupBy = this.organizeByQueryParam;
      }
      this.$api
        .getActivitiesList(filterObjStringified, queryParams)
        .then(response => {
          if (response.data.result) {
            const newActivitiesData = response.data.result[tableTitle];
            this.activities[tableTitle] = newActivitiesData;
            _.forEach(this.activities[tableTitle].rows, activity => {
              if (activity.typeId && this.activityTypes[activity.typeId]) {
                activity.type = this.activityTypes[activity.typeId].type;
              }
              if (activity.therapeuticAreaId && this.therapeuticAreas[activity.therapeuticAreaId]) {
                activity.therapeuticArea = this.therapeuticAreas[activity.therapeuticAreaId].name;
              }
            });
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Published activities");
        });
    }
  },

  created() {
    this.getTherapeuticAreas();
    this.getActivityViews();
    this.getActivityTypes();
  }
};
</script>

<style>
.device-view-btn {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
}
.activity-data-name-preview {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.device-view-preview {
  margin: 0 auto;
  position: relative;
  top: -123px;
}
</style>
